import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SelectItem } from './select.service';
import { ChangedItemsEvent, SelectComponent } from './select.component';
import { HubstaffTaskDTO } from '../../core/models/hubstaff-entities.model';

export interface ChangedTasksEvent {
  selectedTasks: HubstaffTaskDTO[];
}

@Component({
  selector: 'app-select-task',
  template: `<app-select
    [id]="'select-task'"
    [placeholder]="'Select project and then task'"
    [items]="items"
    [initItemIds]="initItemIds"
    [showClearAll]="true"
    [enabled]="tasks.length > 0"
    (changeEvent)="handleSelectedItems($event)"
  ></app-select>`,
  imports: [SelectComponent],
})
export class SelectTaskComponent implements OnChanges {
  @Input() tasks: HubstaffTaskDTO[] = [];
  @Input() selectedTask?: HubstaffTaskDTO | null = null;
  @Output() changedTasksEvent = new EventEmitter();
  items: SelectItem[] = [];
  initItemIds: string[] = [];

  ngOnChanges(): void {
    this.initItemIds = [];
    if (this.selectedTask) {
      this.initItemIds = [this.selectedTask.id];
    }

    this.items = this.tasks.map(task => {
      return {
        id: task.id,
        text: task.name ?? task.summary,
      };
    });
  }

  handleSelectedItems(event: ChangedItemsEvent): void {
    const selectedTasks = this.tasks.filter(task => {
      return event.selectedItems.includes(task.id);
    });

    this.changedTasksEvent.emit({ selectedTasks });
  }
}
